<template lang="html">
  <div id="scroll-indicator" class="d-block d-sm-none" aria-hidden="true">
		<div id="scroll-bar" class="blue"></div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      scrollTimeout: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.checkScroll);
  },
  methods: {
    checkScroll() {
  		clearTimeout(this.scrollTimeout);
  		this.scrollTimeout = setTimeout(function() {
  			var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  		  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  			var scrolled = (winScroll / height).toFixed(2);
  			document.getElementById('scroll-bar').style.width = ((scrolled*100)+10)+'%';
  		}, 10);
  	},
  }
}
</script>

<style lang="css" scoped>
#scroll-indicator {
	position: fixed;
	z-index: 1000;
	bottom: 0px;
	left: 0;
	width: 100%;
	height: 10px;
	/*padding: 2px 5px;*/
	background-color: #f8f8f8;
	text-align: center;
	box-shadow: 0 -2px 3px rgba(0,0,0,0.1);
	border-top: 1px solid #eee;
	-webkit-transition: opacity 0.5s ease-in;
    -moz-transition: opacity 0.5s ease-in;
    -o-transition: opacity 0.5s ease-in;
    -ms-transition: opacity 0.5s ease-in;
    transition: opacity 0.5s ease-in;
}

#scroll-bar {
	min-width: 10%;
	max-width: 100%;
  width: 10%;
	height: 100%;
	-webkit-transition: width 0.2s ease-in;
  -moz-transition: width 0.2s ease-in;
  -o-transition: width 0.2s ease-in;
  -ms-transition: width 0.2s ease-in;
  transition: width 0.2s ease-in;
}
</style>
